import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalComponent, ModalFooterDirective, ToastService } from 'mbs-ui-kit';
import { catchError, Observable, of, take } from 'rxjs';

import { I18NextPipe } from 'angular-i18next';

import { CommonModule } from '@angular/common';

@Component({
  selector: 'mbs-release-modal',
  templateUrl: './release-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AlertComponent, ButtonComponent, CommonModule, I18NextPipe, ModalComponent, ModalFooterDirective]
})
export class ReleaseModalComponent {
  private toastService = inject(ToastService);

  public loading = false;

  public MbsPopupType = MbsPopupType;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  release(): void {
    this.loading = true;

    const request = this.baseModal.data.request as Observable<any>;

    request
      .pipe(
        take(1),
        catchError(() => {
          this.loading = false;
          return of(false);
        })
      )
      .subscribe((result) => {
        const error = result?.find((res) => !res.ok);
        if (error) {
          this.toastService.error(error.errorDescription);
        }

        this.baseModal.save();
        this.loading = false;
      });
  }
}
